// Core
import { useState } from 'react';
import { useQuery } from 'react-query';
import { Box, Grid } from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import Giveaways from '../../Giveaways/components/Giveaway';

const GiveawayWinners = ({setGiveawayWinnersIsHidden}) => {
	const [data, setDate] = useState([]);
    const { isLoading } = useQuery({
        queryKey: ['winners'],
        queryFn: async () => {
            const response = await apiService.getGiveaways({ limit: 3, offset: 0, status: 'finished' });
            setDate(response.data);
            if(response.data.length !== 0){
                setGiveawayWinnersIsHidden(false);
            }
            return true;
        },
        refetchOnWindowFocus: false,
        retry: false
    });

    return (
    	<>
    	{ isLoading ? (<></>) : (
	        <Grid templateColumns={{ sm: '1fr', lg: '1fr 1fr 1fr' }} gap="24px" templateRows='1fr'>
			    { data?.map((item, index) => (
			        <Giveaways key={index} item={item} type="winners" />
			    ))}	
	        </Grid>
	    )}
	    </>
    );
};


export default GiveawayWinners;